import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, fmtINR } from "@/lib/api";
import { CheckCircle2, Clock } from "lucide-react";

export default function OrderSuccess() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);

  useEffect(() => {
    api.get(`/orders/${id}`).then((r) => setOrder(r.data));
  }, [id]);

  if (!order) return <div className="mx-auto max-w-3xl px-4 py-20 text-white/60">Loading...</div>;

  const paid = order.status === "paid";

  return (
    <div data-testid="order-success" className="mx-auto max-w-3xl px-4 sm:px-6 py-16">
      <div className="border border-white/10 bg-zinc-950 p-8">
        <div className="flex items-center gap-3 mb-3">
          {paid ? <CheckCircle2 className="h-8 w-8 text-emerald-400"/> : <Clock className="h-8 w-8 text-yellow-400"/>}
          <h1 className="font-display text-3xl">{paid ? "Order confirmed" : "Order pending"}</h1>
        </div>
        <p className="text-white/60 mb-6">Order ID: <span className="font-mono text-white">{order.id}</span></p>
        <div className="grid gap-2 text-sm">
          {order.items.map((i, idx) => (
            <div key={idx} className="flex justify-between border-b border-white/5 py-2">
              <span>{i.title} <span className="text-white/50">· {i.variant_name} · × {i.qty}</span></span>
              <span className="font-mono">{fmtINR(i.price_inr * i.qty)}</span>
            </div>
          ))}
          <div className="flex justify-between pt-2"><span className="text-white/60">Shipping</span><span className="font-mono">{order.shipping_inr > 0 ? fmtINR(order.shipping_inr) : <span className="text-emerald-400">FREE</span>}</span></div>
          <div className="flex justify-between text-base pt-2"><span>Total paid</span><span data-testid="order-total" className="font-mono text-xl">{fmtINR(order.total_inr)}</span></div>
        </div>
        <div className="mt-6 flex gap-3">
          <Link data-testid="continue-shopping" to="/shop" className="text-blue-400 hover:text-blue-300">← Continue shopping</Link>
        </div>
      </div>
    </div>
  );
}
